import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Constants, digitalRegTypes, pageInContext, transactionTypes } from "../../utilities/Constants";
import { EAuthClientsResponse } from "../../../setup-eAuthorization/models/EAuthClients";
import { Store } from "@ngrx/store";
import { selectRegType, selectUseTestTrustDigitalToPdfFlow } from "../../../account-info-header/reducers";
import { combineLatest, Subject, takeUntil } from "rxjs";
import { selectViewInContext } from "../../reducers";
import { FeatureFlagService } from "../../services/feature-flag-service";
import { selectFrequency, selectIs401kToAccount, selectTransactionType } from "../../../create-request/reducers";
import { selectisStandingAuthI401KToAccount } from "../../../standing-authorizations/reducers";
@Component({
  standalone: false,
    selector: 'mm-ineligible-account',
    templateUrl: './ineligible-account.component.html',
    styleUrls: ['./ineligible-account.component.scss']
})
export class IneligibleAccountComponent implements OnInit, OnDestroy{
    @Input() eAuthClientsResponse : EAuthClientsResponse;
    @Input() isEAuth : boolean;
    @Input() transactionType : string;
    destroy$: Subject<boolean> = new Subject<boolean>();
    useTestTrustDigitalToPdfFlow: boolean;
    step: string;
    selectedFrequency: string;    
    regType: string;
    is401kToAccount: boolean;

    constructor(private store: Store, private flagService: FeatureFlagService) {}

    ngOnInit(): void {
        this.store.select(selectUseTestTrustDigitalToPdfFlow).pipe(takeUntil(this.destroy$)).subscribe((val) => {
            this.useTestTrustDigitalToPdfFlow = val;
        });

        this.store.select(selectViewInContext).pipe(takeUntil(this.destroy$)).subscribe((step) => {
            this.step = step;
        });

        this.store.select(selectFrequency).pipe(takeUntil(this.destroy$)).subscribe((frequency) => {
            this.selectedFrequency = frequency ?? '';
        })

        this.store.select(selectRegType).pipe(takeUntil(this.destroy$)).subscribe(regType => { this.regType = regType }) 

        combineLatest([
            this.store.select(selectIs401kToAccount),
            this.store.select(selectisStandingAuthI401KToAccount),
        ]).pipe(takeUntil(this.destroy$)).subscribe(([is401kToAccount, isSA401kToAccount]) => {
            this.is401kToAccount = is401kToAccount || isSA401kToAccount;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }

    get ineligibleAccountPrimaryText(): string {
        if (this.selectedFrequency === 'onetimeTotalDist' || this.is401kToAccount){
            return Constants.totalDistributionD2PEauthText;
        }

        if ((this.transactionType && this.transactionType !== transactionTypes.check) 
            && !this.useTestTrustDigitalToPdfFlow
        ) {
            return Constants.ineligibleForEauthPrimaryText;
        }
        
        if ((this.transactionType && this.transactionType !== transactionTypes.check) 
            && this.useTestTrustDigitalToPdfFlow
        ) {
            return this.step === pageInContext.confirmation ? Constants.digitalToPdfPrimaryConfirmationPageText : Constants.digitalToPdfPrimaryEauthText;
        }

        if(this.isEAuth == true) {
            return this.eAuthClientsResponse?.isAccountRestricted ? Constants.accountIneligibleForEauthSecondaryText : Constants.ineligibleForEauthText;
        }

        return Constants.ineligibleForEauthPrimaryText;
    }
    get ineligibleAccountSecondaryText(): string {

        const isEauthRestricted = this.eAuthClientsResponse?.isAccountRestricted;
        const isTestTrust = this.useTestTrustDigitalToPdfFlow;
        const isOneTimeTotalDist = this.selectedFrequency === 'onetimeTotalDist';

        const showEauthIneligibleText = isEauthRestricted || isTestTrust || isOneTimeTotalDist || this.is401kToAccount;

        return showEauthIneligibleText ? Constants.accountIneligibleForEauthSecondaryText : Constants.accountIneligibleNoAccountHoldersForEauthSecondaryText;
    }
}
